import { FUND_RULES_DECLARATIONS } from '@/data/fundRulesDeclarations';
import { ruleIcons } from './fundRuleGlyphs';
import styles from './FundRulesGrid.module.scss';

/**
 * The four fund rules as a stack of rows, each with its own glyph, the title and its sentence
 * running on together.
 *
 * Shared by the open-fund request's pre-submit popup and the portal's entry gate (HAT-1256), which
 * put the same rules in front of a person at two different moments and must not drift apart.
 *
 * HAT-1258: this was a 2x2 grid of cards, which read as a wall of text. Rows carry the same four
 * rules in far less ink. The order is FUND_RULES_DECLARATIONS' own, which is the order printed
 * into the PDFs, so there is no separate display order to keep in step.
 */
const FundRulesGrid = () => (
  <ul className={styles.rules}>
    {FUND_RULES_DECLARATIONS.map((declaration) => (
      <li key={declaration.id} className={styles.rule}>
        <span className={styles.ruleIcon}>
          <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
            {ruleIcons[declaration.id]}
          </svg>
        </span>
        <p className={styles.ruleBody}>
          <span className={styles.ruleTitle}>{declaration.title}</span>
          <span className={styles.ruleText}>{declaration.text}</span>
        </p>
      </li>
    ))}
  </ul>
);

export default FundRulesGrid;
